import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { ComptaRoutingModule } from './compta-routing.module';
import { ComptaComponent } from './compta/compta.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FactureEntreeComponent } from './facture-entree/facture-entree.component';
import { FactureSortieComponent } from './facture-sortie/facture-sortie.component';
import { TableModule } from 'primeng/table';
import { InvoiceViewComponent } from './invoice-view/invoice-view.component';
import { InvoiceOutViewComponent } from './invoice-out-view/invoice-out-view.component';
import { InvoiceTabComponent } from './invoice-tab/invoice-tab.component';
import { InvoiceOutEditComponent } from './invoice-out-edit/invoice-out-edit.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MatSelectModule } from '@angular/material';
import { ComponentsModule } from '../components/components.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';

import { PanelModule } from 'primeng/panel';
import { InvoiceInViewComponent } from './invoice-in-view/invoice-in-view.component';
import { InvoiceInEditComponent } from './invoice-in-edit/invoice-in-edit.component';
import { PaiementAddComponent } from './paiement-add/paiement-add.component';
import { CalendarModule } from 'primeng/calendar';
import { PaiementListComponent } from './paiement-list/paiement-list.component';
import { PaiementsComponent } from './paiements/paiements.component';
import { PrestationToInvoiceComponent } from './prestation-to-invoice/prestation-to-invoice.component';
import { TimesheetComponent } from './timesheet/timesheet.component';
import { NgxPermissionsModule } from 'ngx-permissions';


@NgModule({
  declarations: [ComptaComponent, FactureEntreeComponent, FactureSortieComponent, InvoiceViewComponent, InvoiceOutViewComponent, InvoiceTabComponent, InvoiceOutEditComponent, InvoiceInViewComponent, InvoiceInEditComponent, PaiementAddComponent, PaiementListComponent, PaiementsComponent, PrestationToInvoiceComponent, TimesheetComponent],
  imports: [

    CommonModule,
    ComptaRoutingModule,
    MatTabsModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    TableModule,
    FormsModule,
    ReactiveFormsModule,
    ToastModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ComponentsModule,
    DragDropModule,
    ToolbarModule,
    ButtonModule,
    PanelModule,
    CalendarModule,
    NgxPermissionsModule.forChild()
  ],
  exports: [
  	ComptaComponent
  ]
})
export class ComptaModule { }
